<template>
    <div>
        <div class="header mt-5">
            {{ $vuetify.lang.t('$vuetify.companySetting.companySetting')}}
        </div>

        <nav-bar
            ref="navbar"
            @menu-change="menuChange"
            :menuItem="navbarList" />

        <component :is="component" />
    </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
import CompanyProfile from '@/components/CompanySetting/CompanyProfile.vue'
import UserManagement from '@/components/CompanySetting/UserManagement.vue'
import Positions from '@/components/CompanySetting/Positions.vue'
import Bureau from '@/components/CompanySetting/Bureau.vue'
import LineService from '@/components/CompanySetting/LineService.vue'

export default {
    name: 'CompanySetting',

    components: {
        NavBar,
        CompanyProfile,
        UserManagement,
        Positions,
        Bureau,
        LineService
    },

    data () {
        return {
            component: '',
            userPermissions: [],
            menuItem: [
                {
                    title: this.$vuetify.lang.t('$vuetify.companySetting.profile'),
                    path: 'CompanyProfile',
                    pathName: 'company-profile',
                    permission: []
                },
                {
                    title: this.$vuetify.lang.t('$vuetify.companySetting.bureau'),
                    path: 'Bureau',
                    pathName: 'bureau',
                    permission: []
                },
                {
                    title: this.$vuetify.lang.t('$vuetify.companySetting.position'),
                    path: 'Positions',
                    pathName: 'positions',
                    permission: []
                },
                {
                    title: 'Line Service',
                    path: 'LineService',
                    pathName: 'line-service',
                    permission: []
                },
                {
                    title: this.$vuetify.lang.t('$vuetify.companySetting.userManagement'),
                    path: 'UserManagement',
                    pathName: 'user-management',
                    permission: []
                }
            ],
            mappedTranslation: {
                CompanyProfile: 'profile',
                UserManagement: 'userManagement',
                Bureau: 'bureau',
                Positions: 'position',
                lineService: 'lineService'
            }
        }
    },

    computed: {
        navbarList () {
            const navbar = []
            for (const item of this.menuItem) {
                navbar.push(item)
            }
            return navbar
        }
    },

    methods: {

        setLangNavBar () {
            for (let i = 0; i < this.menuItem.length; i++) {
                if (this.mappedTranslation[this.menuItem[i].path]) {
                    this.menuItem[i].title = this.$vuetify.lang.t(`$vuetify.companySetting.${this.mappedTranslation[this.menuItem[i].path]}`)
                }
            }
        },

        menuChange (payload) {
            this.component = payload.path

            const path = `/company/setting/${this.navbarList[payload.index].pathName}`
            if (this.$route.path !== path) {
                this.$router.replace(path)
            }
        },

        navbarPermission () {
            this.component = this.navbarList[0].path
        },

        setActive (path) {
            let index = 0
            if (path === 'CompanySetting') {
                this.$refs.navbar.go(this.navbarList[0].pathName, index)
            } else {
                index = this.navbarList.findIndex(x => x.path === path)
                this.$refs.navbar.go(path, index)
            }

            const directPath = `/company/setting/${this.navbarList[index].pathName}`
            if (this.$route.path !== directPath) {
                this.$router.replace(directPath)
            }
        }
    },

    mounted () {
        this.userPermissions = this.$store.state.permissions
        this.navbarPermission()
        this.setActive(this.$router.currentRoute.name)
    },

    watch: {
        '$vuetify.lang.current': {
            handler: function (after, before) {
                this.setLangNavBar()
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
.header {
    display: flex;
    justify-content: space-between;
    font-size: 28px;
    font-weight: bold;
}
</style>
